// MATERIAL UI
import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const PageWithHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabsContainer: {
      marginBottom: "2rem",
      minHeight: "auto",
      marginTop: "10px",
      [theme.breakpoints.down("md")]: {
        marginLeft: "16px",
      },
    },
    tab: {
      padding: "12px 2px",
      marginRight: "24px",
      minWidth: "auto",
      minHeight: "auto",
      textTransform: "none",
      fontFamily: "Roobert, sans-serif",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "20px",
      color: "#5C6469",
      position: "relative",
      "&:hover": {
        color: "#002035",
        "&::after": {
          content: '""',
          display: "block",
          width: "100%",
          height: "1px",
          backgroundColor: "#FC4C4C",
          position: "absolute",
          bottom: 0,
        },
      },
    },
    activeTab: {
      fontWeight: 500,
      color: "#002035",
      borderBottom: "1px solid #FC4C4C",
    },
  }),
);
